module.exports = __webpack_public_path__ + "img/sh.aa5540bb.svg";